<div class="m-2">
  <h2 class="text-danger">{{ 'ml_143952' | translate }}</h2>

  <div mat-dialog-content>
    <app-data-grid [dataSource$]="dataSource$" [columnsDef]="importResultDataGridColumnDef">
      <ng-template #cellContent let-data="data" let-column="column">
        <app-import-data-result-data-grid-cell [data]="data" [field]="column.name" [column]="column"></app-import-data-result-data-grid-cell>
      </ng-template>
    </app-data-grid>
  </div>

  <div mat-dialog-actions class="row mt-2 p-2 justify-content-end">
    <div class="col-auto align-self-end">
      <button class="button--default" [mat-dialog-close]="true">{{ 'ml_143929' | translate}}</button>
    </div>
  </div>
</div>
